import PropTypes from 'prop-types';

import './SamplePackRow.css';

import { useStorage } from '../../../hook/useStorage';
import { buildClass } from '../../../libs/classes';

/**
 * Sample pack row for list component
 * Pack is a summary of similar card samples
 * @component
 */
export const SamplePackRow = ({ pack, unfold, showStorage = true, isOwned, onClick, children }) => {
	const { getStorageTitleShort, getStorageTitleFull } = useStorage();

	return (
		<div className={buildClass('sample-list-pack-row').add(unfold, 'unfold')}>
			<div className="summary" onClick={handleClick}>
				{showStorage && isOwned ? (
					<div className="storage_code" title={getStorageTitleFull(pack.storage_id)}>
						{getStorageTitleShort(pack.storage_id)}
					</div>
				) : null}
				<div className="card_number" title={pack.set ? pack.set.name : '?'}>
					<span className="set_code">{pack.set ? pack.set.code : '?'}</span>&nbsp;
					<span className="c_number">{pack.card ? pack.card.c_number : '?'}</span>&nbsp;
				</div>
				<div className="language">
					<span className="flag" />
				</div>
				<div className="unfold-state">
					<div className="state" />
				</div>
				<div className="qty">{pack.count}&#8202;×</div>
				<div className={buildClass('name', `rarity-${pack.card.rarity}`)}>{pack.card.name}</div>
			</div>
			{children}
		</div>
	);

	function handleClick() {
		onClick(pack.card.id);
	}
};

SamplePackRow.propTypes = {
	// Pack of samples
	pack: PropTypes.object.isRequired,
	// Is pack unfolded
	unfold: PropTypes.bool.isRequired,
	// Flag that the storage should be displayed
	showStorage: PropTypes.bool,
	// Is pack owned
	isOwned: PropTypes.bool.isRequired,
	// Callback function on click
	onClick: PropTypes.func.isRequired,
	// Content of the pack (list of SampleRow components)
	children: PropTypes.node.isRequired,
};

export default SamplePackRow;
